import { END_POINTS } from "../constants/url";
import emptySplitApi from "../utils/rtk";

interface CommonResponseType {
  status: number;
  message: string;
  statusCode: number;
}

interface PostLoginBody {
  email: string;
  password: string;
}

export const usersApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getUsers: builder.query<
      CommonResponseType & { data: any },
      {
        search?: string;
        start?: number;
        length?: number;
      }
    >({
      query: ({ length, search, start }) => ({
        url: `${END_POINTS.users}?start=${start}&length=${length}&search=${search}`,
        method: "GET",
      }),
    }),
    getUserById: builder.query<
      CommonResponseType & { data: any },
      {
        id: number;
      }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.users}${id}/`,
        method: "GET",
      }),
    }),
    getUserTasksById: builder.query<
      CommonResponseType & { data: any },
      {
        id: number;
      }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.userTasks}`,
        method: "POST",
        body: { user_id: id },
      }),
    }),
    getUserExpenseById: builder.query<
      CommonResponseType & { data: any },
      {
        id: number;
      }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.userExpense}`,
        method: "POST",
        body: { user_id: id },
      }),
    }),
    updateUsers: builder.mutation<
      CommonResponseType,
      { body: any; id: number }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updateUser}${id}/`,
        method: "PUT",
        body,
      }),
    }),
    userAction: builder.mutation<CommonResponseType, { body: any; id: number }>(
      {
        query: ({ body, id }) => ({
          url: `${END_POINTS.users}/${id}`,
          method: "PATCH",
          body,
        }),
      }
    ),
    deleteUser: builder.mutation<CommonResponseType, { id: number }>({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteUser}${id}/`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useDeleteUserMutation,
  useLazyGetUserByIdQuery,
  useLazyGetUsersQuery,
  useLazyGetUserTasksByIdQuery,
  useLazyGetUserExpenseByIdQuery,
  useUpdateUsersMutation,
  useUserActionMutation,
  useGetUsersQuery,
} = usersApi;
